import {WeekDay} from 'enums';

export type WorkingHoursTimePoint = {
    hours: number;
    minutes: number;
}

export type WorkingHoursInterval = {
    from: WorkingHoursTimePoint;
    to: WorkingHoursTimePoint;
}

export enum SpecialDayRepeat {
    NoRepeat = 'no-repeat',
    // TODO: add daily
    // TODO: add weekly
    Monthly = 'monthly',
    Annually = 'annually'
}

export type WeekDayWorkingHours = {
    intervals: WorkingHoursInterval[];
};

export type SpecialDayWorkingHoursItem = WeekDayWorkingHours & {
    name?: string;
    repeat: SpecialDayRepeat;
    day: number;
    month: number;
    year: number;
}

export type WeekWorkingHours = {
    [WeekDay.Monday]: WeekDayWorkingHours;
    [WeekDay.Tuesday]: WeekDayWorkingHours;
    [WeekDay.Wednesday]: WeekDayWorkingHours;
    [WeekDay.Thursday]: WeekDayWorkingHours;
    [WeekDay.Friday]: WeekDayWorkingHours;
    [WeekDay.Saturday]: WeekDayWorkingHours;
    [WeekDay.Sunday]: WeekDayWorkingHours;
}

export type WorkingHours = {
    enabled: boolean;
    weekHours: WeekWorkingHours;
    specialHours: SpecialDayWorkingHoursItem[];
}